import { useState, useContext, useEffect } from "react";
import { Form, Tooltip, Modal, FormSelect } from "react-bootstrap";
import axios from "axios";
import { AuthContext } from "../../../../contexts/AuthContext";
import "./Auditoria.css";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import * as links from "../../../../utils/links";
import moment from "moment";
import { Input, Button, Row } from "antd";
import checkImage from "../../../../assets/images/image_check.png";
import AuditoriaListTable from "./AuditoriaListTable";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingAction from "../../../../themes/LoadingAction/LoadingAction";
import CustomDateRangePicker from "./CustomDatePicker/CustomRangePicker";

export default function Auditoria() {

    const location = useLocation();
    const clienteInfo = location.state;

    const { setDataUser, authInfo, setNotiMessage } = useContext(AuthContext);
    const { dataUser } = authInfo;
    const [isLoading, setIsLoading] = useState(true);
    const [pagamentos,setPagamentos] = useState([])

    let navigate = useNavigate();
    const token = authInfo?.dataUser?.token;
    const [paymentResponse, setPaymentResponse] = useState("");
    const [loadingTable, setLoadingTable] = useState(false);
    const [listMensals, setListMensals] = useState([]);
    const [dataInicio, setDataInicio] = useState(null);
    const [dataFim, setDataFim] = useState(null);
    const [somaAtraso, setSomaAtraso] = useState("");
    const [proximaParcela, setProximaParcela] = useState("");
    const [dataVencimento, setDataVencimento] = useState("");
    const [showModal, setShowModal] = useState(false);  // Estado para controlar a visibilidade da modal
    const [copied, setCopied] = useState(false);
    const [maquinas, setMaquinas] = useState([])
    const [tipoPagamento, setTipoPagamento] = useState('')
    const [filtro, setFiltro] = useState({
        maquinaId: '',
        pagamentoId: ''
    });

    const { id } = useParams();

    useEffect(() => {
        buscaMaquinas()
    }, []);

    const buscaMaquinas = () => {
        setIsLoading(true);
        axios.get(`${process.env.REACT_APP_SERVIDOR}/maquinas-adm?id=${id}`, {
            headers: {
                "x-access-token": token,
                "content-type": "application/json",
            },
        }).then((res) => {
            if (res.status === 200) {
                setIsLoading(false);
                setMaquinas(res.data);
                console.log(res.data)
            } else {
                throw new Error();
            }
        }).catch((err) => {
            setIsLoading(false);
            if ([401, 403].includes(err.response.status)) {
                setNotiMessage({
                    type: "error",
                    message:
                        "A sua sessão expirou, para continuar faça login novamente.",
                });
                if (dataUser.key === 'ADMIN') {
                    navigate(links.ADMIN_SIGNIN)
                    setDataUser(null);
                } else {
                    navigate(links.SIGNIN)
                    setDataUser(null);
                }
            }
        });
    };

    const buscaPagamentos = () => {
        setIsLoading(true);
        console.log(filtro)
        axios.post(`${process.env.REACT_APP_SERVIDOR}/auditoria-pagamentos`, {
            tipoPagamento: tipoPagamento,
            dataInicio: dataInicio,
            dataFim: dataFim,
            pagamentoId: filtro.pagamentoId,
            maquinaId: filtro.maquinaId
        }, {
            headers: {
                "x-access-token": token,
                "content-type": "application/json",
            },
        }).then((res) => {
            if (res.status === 200) {
                setIsLoading(false);
                console.log(res.data.pagamentos)
                setPagamentos(res.data.pagamentos);
            } else {
                throw new Error();
            }
        }).catch((err) => {
            setIsLoading(false);
            if ([401, 403].includes(err.response.status)) {
                setNotiMessage({
                    type: "error",
                    message:
                        "A sua sessão expirou, para continuar faça login novamente.",
                });
                if (dataUser.key === 'ADMIN') {
                    navigate(links.ADMIN_SIGNIN)
                    setDataUser(null);
                } else {
                    navigate(links.SIGNIN)
                    setDataUser(null);
                }
            }
        });
    };

    const updateTable = () => {
        getData(id);
    }

    const getData = (id) => {
        if (id.trim() !== "") {
            setLoadingTable(true);
            axios
                .get(`${process.env.REACT_APP_SERVIDOR}/parcelas?clienteId=${id}`, {
                    headers: {
                        "x-access-token": token,
                        "content-type": "application/json",
                    },
                })
                .then((res) => {
                    setLoadingTable(false);
                    setSomaAtraso(res?.data?.somaAtraso);
                    setProximaParcela(res?.data?.proximaParcela);
                    setDataVencimento(res?.data?.dataVencimento);
                    if (res.status === 200 && Array.isArray(res.data.parcelas)) {
                        setListMensals(res.data.parcelas);
                    }
                })
                .catch((err) => {
                    setLoadingTable(false);
                    if ([401, 403].includes(err.response.status)) {
                        toast.error("A sua sessão expirou, para continuar faça login novamente.")
                        if (dataUser.key === 'ADMIN') {
                            navigate(links.ADMIN_SIGNIN)
                            setDataUser(null);
                        } else {
                            navigate(links.SIGNIN)
                            setDataUser(null);
                        }
                    }
                });
        }
    };

    const formatarParaMoeda = (value) => {
        if (!value) return "";
        let valorNumerico = value.replace('R$', '').replace(',', '.');
        let valorFloat = parseFloat(valorNumerico.trim());
        return valorFloat;
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(paymentResponse?.qr_code)
            .then(() => setCopied(true))
            .catch(err => console.error('Erro ao copiar para a área de transferência: ', err));
    };

    return (
        <div class="container mw-100">
            {isLoading && <LoadingAction />}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h1 className="h4 fw-bold">Relatório de Auditoria de Pagamento: {clienteInfo?.nome}</h1>
                <div className="d-flex col-8 col-md-auto mb-2">
                    <button className="custom-btn btn btn-outline-secondary"
                        onClick={() =>
                            navigate(`${links.DASHBOARD_CLIENTES}`, {
                                state: clienteInfo,
                            })
                        }>VOLTAR</button>
                </div>
            </div>
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4 mb-4">
                <div className="col-7 col-lg-3 mb-2">
                    <Form.Select
                        className="ik-native-select"
                        style={{
                            border: '1px solid rgba(255, 255, 255, 0.14)',
                            borderRadius: '0.25rem',
                            textAlign: 'center',
                            width: '100%',
                            padding: '12px',
                            fontSize: '16px',
                            appearance: 'none', // Remove estilos nativos do select
                            background: 'rgba(255, 255, 255, 0.04)',
                            backgroundImage: 'none',
                            color: 'rgba(233, 242, 255, 0.85)',
                            cursor: 'pointer',
                        }}
                        value={tipoPagamento}
                        id="tipoPagamento"
                        name="tipoPagamento"
                        onChange={(e) => {
                            console.log(e.target.value)
                            setTipoPagamento(e.target.value)
                        }}
                    >
                        <option value="">Tipo de Busca</option>
                        <option value="MAQUINA">Por Máquina</option>
                        <option value="PAGAMENTO">Por Pagamento</option>
                    </Form.Select>
                </div>
                {tipoPagamento === 'MAQUINA' ?
                    <>
                        <div className="col-7 col-lg-3 mb-2">
                            <Form.Select
                                className="ik-native-select"
                                style={{
                                    border: '1px solid rgba(255, 255, 255, 0.14)',
                                    borderRadius: '0.25rem',
                                    textAlign: 'center',
                                    width: '100%',
                                    padding: '12px',
                                    fontSize: '16px',
                                    appearance: 'none', // Remove estilos nativos do select
                                    background: 'rgba(255, 255, 255, 0.04)',
                                    backgroundImage: 'none',
                                    color: 'rgba(233, 242, 255, 0.85)',
                                    cursor: 'pointer',
                                }}
                                value={filtro.maquinaId}
                                id="tipoPagamento"
                                name="tipoPagamento"
                                onChange={(e) => {
                                    setFiltro({
                                        maquinaId: e.target.value
                                    })
                                }}
                            >
                                <option value="">Escolha a máquina</option>
                                {maquinas.map((maquina) =>
                                    <option value={maquina.id}>{maquina.nome}</option>
                                )}
                            </Form.Select>
                        </div>
                        <div className="col-7 col-lg-3 mb-2">
                            <CustomDateRangePicker setDataFim={setDataFim} setDataInicio={setDataInicio} resetSearch={getData} id={id} />
                        </div>
                    </>
                    :
                    null
                }
                {tipoPagamento === 'PAGAMENTO' ?
                    <div className="col-7 col-lg-3 mb-2">
                        <Input
                            style={{
                                border: '2px solid #d9d9d9',
                                borderRadius: '0.25rem',
                                textAlign: 'center',
                                width: '100%',
                                padding: '12px',
                                fontSize: '16px',
                            }}
                            placeholder="Id do Pagamento"
                            value={filtro.pagamentoId}
                            id="diaDoPagamento"
                            type="text"
                            name="diaDoPagamento"
                            min="1"
                            max="31"
                            onChange={(event) => {
                                setFiltro({
                                    pagamentoId: event.target.value
                                })
                            }}
                            onKeyDown={(e) => {
                                if (e.key === '-' || e.key === '+') {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </div>
                    :
                    null
                }


                <div className="col-7 col-lg-3 mb-2">
                    <button
                        className="custom-btn btn btn-primary d-flex w-100 h-100 text-center justify-content-center mb-2"
                        onClick={() => {
                            buscaPagamentos()
                        }}
                    >
                        <span> Buscar Relatório</span>
                    </button>
                </div>
            </div>

            {/* Tabela */}
            <div className="card" style={{ border: '1px solid rgba(0, 0, 0, 0.1)', borderRadius: '8px' }}>
                <div className="card-header">
                    <h5>Relatório de Pagamentos</h5>
                </div>
                <div className="card-body">
                    <AuditoriaListTable updateTable={updateTable} pagamentos={pagamentos} />
                </div>
            </div>
            <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </div>
    );
}
